var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSingapore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 256
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 256.5,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 255
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M86.577,121.683c0-43.383,31.833-79.342,73.398-85.994c2.257-0.361,2.359-3.466,0.132-3.979   c-10.29-2.367-21.22-3.04-32.57-1.494c-44.832,6.106-79.485,44.902-80.119,90.143c-0.723,51.657,40.923,93.721,92.337,93.721   c6.998,0,13.795-0.818,20.333-2.321c2.224-0.511,2.113-3.624-0.141-3.984C118.396,201.126,86.577,165.233,86.577,121.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M160.658,144.896l-3.905,11.71l-12.344,0.096c-1.598,0.012-2.261,2.052-0.975,3.001l9.93,7.333   l-3.724,11.769c-0.482,1.524,1.253,2.785,2.553,1.854l10.042-7.178l10.042,7.178c1.3,0.929,3.035-0.331,2.553-1.854l-3.724-11.769   l9.93-7.333c1.285-0.949,0.623-2.989-0.975-3.001l-12.344-0.096l-3.905-11.71C163.307,143.38,161.163,143.38,160.658,144.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M221.673,144.896l-3.905,11.71l-12.344,0.096c-1.598,0.012-2.261,2.052-0.975,3.001l9.93,7.333   l-3.724,11.769c-0.482,1.524,1.253,2.785,2.553,1.854l10.042-7.178l10.042,7.178c1.3,0.929,3.035-0.331,2.553-1.854l-3.724-11.769   l9.93-7.333c1.285-0.949,0.623-2.989-0.975-3.001l-12.344-0.096l-3.905-11.71C224.323,143.38,222.179,143.38,221.673,144.896z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M191.44,50.738l-3.905,11.71l-12.344,0.096c-1.598,0.012-2.261,2.052-0.975,3.001l9.93,7.333   l-3.724,11.769c-0.482,1.524,1.253,2.785,2.553,1.854l10.042-7.178l10.042,7.178c1.3,0.929,3.035-0.331,2.553-1.854l-3.724-11.769   l9.93-7.333c1.285-0.949,0.623-2.989-0.975-3.001l-12.344-0.096l-3.905-11.71C194.09,49.222,191.945,49.222,191.44,50.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M142.793,86.811l-3.905,11.71l-12.344,0.096c-1.598,0.012-2.261,2.052-0.975,3.001l9.93,7.333   l-3.724,11.769c-0.482,1.524,1.253,2.785,2.553,1.854l10.042-7.178l10.042,7.178c1.3,0.929,3.035-0.331,2.553-1.854l-3.724-11.769   l9.93-7.333c1.285-0.949,0.623-2.989-0.975-3.001l-12.344-0.096l-3.905-11.71C145.443,85.295,143.299,85.295,142.793,86.811z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M239.676,86.811l-3.905,11.71l-12.344,0.096c-1.598,0.012-2.261,2.052-0.975,3.001l9.93,7.333   l-3.724,11.769c-0.482,1.524,1.253,2.785,2.553,1.854l10.042-7.178l10.042,7.178c1.3,0.929,3.035-0.331,2.553-1.854l-3.724-11.769   l9.93-7.333c1.285-0.949,0.623-2.989-0.975-3.001l-12.344-0.096l-3.905-11.71C242.325,85.295,240.181,85.295,239.676,86.811z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingapore);
export default __webpack_public_path__ + "static/media/singapore.a1dfbef515fa7029a2056da9a7aa02ef.svg";
export { ForwardRef as ReactComponent };